var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClevelandIndiansLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 191.45,
    width: 135.77,
    viewBox: "0 0 135.774 191.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e31937",
    d: "m134.51 68.226v-66.618h-31.417v7.24l-7.233-7.24h-62.708l-31.416 31.416v125.62l31.416 31.416h69.94l31.418-31.415v-35.215h-31.417v22.22l-12.995 12.995h-43.93l-13.016-12.995v-99.59l13.017-13.036h43.93l12.994 13.037v22.165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClevelandIndiansLogo);
export default __webpack_public_path__ + "static/media/cleveland-indians-logo.ee64c9d9a39b45b1ef0591474a147bf3.svg";
export { ForwardRef as ReactComponent };